import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dropdown from 'react-bootstrap/Dropdown'
import "./Dropdownx.scss"
function Dropdownx() {
  return <div className='dropdown_Div'>
      <Dropdown>
  <Dropdown.Toggle variant="success" id="dropdown-basic">
   
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
  </div>;
}
export default Dropdownx;